import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "welcome": "Welcome to Keito",
      "eHealth": "Contacts",
      "intro": "Please enter your user nº and password",
      "userNumber": "User nº",
      "userNumberPlaceholder": "User nº",
      "titlePassword": "Password",
      "password": "Password",
      "passwordPlaceholder": "Your password",
      "rememberMe": "Remember me",
      "login": "Log-in",
      "noAccount": "Do not you have an account yet?",
      "authError": "Log-in error",
      //Register
      "signUp": "Join",
      "title-register": "Join Keito",
      "intro-register": "Please complete the information to create your account",
      "genderAtBirth": "Gender",
      "male": "Male",
      "female": "Female",
      "dateOfBirth": "Date of birth",
      "dateOfBirthPlaceholder": "Your date of birth",
      "enterPassword": "Please enter your password",
      "newPasswordPlaceholder": "Your new password",
      "repeatPassword": "Please re-enter your password",
      "repeatPasswordPlaceholder": "Please re-enter your new password",
      "acceptTerms": "Agree to Terms & Conditions",
      "register": "Register",
      "noOrders": "No contacts available",
      "alreadyHaveAccount": "¿Already have an account?",
      "signIn": "Start session",
      "titleMesurements": "My readings",
      "errorDate": "Please enter your date of birth!",
      "errorAccept": "Please agree to Terms & Conditions",
      "errorPswIncorrect": "Password format incorrect. Password must include at leat 5 letters or digits",
      //MainScreen
      "weight": "Weight",
      "weight-units": "Kg",
      "height": "Height",
      "height-units": "Cm",
      "bmi": "BMI",
      "bmi-units": "Kg/m",
      "pressure": "Blood pressure",
      "pressure-units": "mmHg",
      "max-Sis": "Systolic pressure",
      "min-Dias": "Diastolic pressure",
      "temperature": "Body temperature",
      "temperature-exp": "Temp.",
      "temperature-units": "ºC",
      "spo2": "SpO2",
      "spo2-units": "%",
      "pulse": "Pulse",
      "pulse-units": "ppm",
      "bfi": "Fat %",
      "bfi-units": "%",
      "snormal": "Normal",
      "shigh": "High",
      "verylow": "Very low",
      "low": "Low",
      "mediumlow": "Med-Low",
      "mediumhigh": "Med-High",
      "high": "High",
      "veryhigh": "Very high",
      "deletedAccount": "This account has been deleted.",
      "sureDelete": "Are you sure you would like to delete your account?",
      "errorDelete": "Error while deleting your account.",
      "delete": "Delete",
      "changePassword": "Change your password",
      "formatIncorrect": "Password format incorrect",
      "passwordOk": "The password has been updated successfully.",
      "errorChangePassword": "Error while changing your password",
      "closeSession": "Log out",
      "deleteUser": "Delete my account",
      "alias": "Alias (Optional)",
      "sureDeleteFromList": "Are you sure you want to delete the user from the list?",
      "addUser": "Add User",
      "userExist": "The user already exists in the list",
      "default": "Default",
      "healthConnectNotAvailable": "Health plugin not available. Please go to Play Store and download the Health Connect app. Ensure to grant permissions to Google Fit and Keito eHealth.",
      "goToPlayStore": "Go to Play Store",
      "connectWithAppsAndroid": "Connect with Google Fit",
      "connectWithAppsIos": "Connect with Apple Health",
      "disconnectFromApps": "Disconnect from apps...",
      //User birthdate ok
      "needinfo": "Please indicate your gender, date of birth and final password",
      "errorBirthDate": "You must select your gender, date of birth, password and accept the Conditions and Terms of use!",
      //Añadir o Registrar Usuario Dialog
      "addOrRegUser": "Do you want to add an existing user or register a new one?",
      "userRegistered": "User Registered",
      "regiterUser": "Register User",
      "addChangeUser": "Add/Change User",
      "associateUser": "Associate User",
      //Pantalla QR
      "identifyTitle": "Identify yourself on a Keito device",
      "selectCodeType": "Select",
      "codeType": "Type of code",
      "helpGifAltText": "Keito eHealth Help Gif",
      "insertCodeInstructions": "Scan your code on the equipment as shown in this video",
      "needHelp": "Do you need help?",
      "contactUs": "Contact us",
      //Pantalla Last Ticket
      "lastTicket": "Last report",
      "ticket": "Ticket",
      "equipmentNumber": "Device",
      "userId": "User",
      "userAge": "Age",
      "userSex": "Gender",
      "measurements": "Readings",
      "references": "References",
      "title-bfi": 'Estimated body fat',
      "%-bfi": "Fat %",
      "windex-bfi": "Body water percentage",
      "fmass-bfi": "Fat mass",
      "fwmass-bfi": "Fat-free mass",
      "wmass-bfi": "Body water",
      "normalWeightBetween": "Ideal weight between",
      "and": "and",
      "yourBmiIs": "Your BMI is",
      "shouldBeBetween": "Ideally, it should be between",
      //revisar WHO
      "bloodPressureAccordingToWHO": "Blood pressure in mmHg according to the WHO",
      "normalUntil": "Ideal, Until",
      "highBetween": "High, Between",
      "hypertension": "Hypertension",
      "normalSpo2Value": "Ideal value of Pulse oximetry",
      "normalSpo2Between": "Ideal between",
      "normalFatIndex": "Ideal Body fat percentage",
      "normalFatMass": "Ideal value of Body fat",
      "noMeasures": "There are no readings in your account yet",
      "noMeasuresUser": "This user has no measures recorded in this interval",
      "noMeasuresInterval": "There are no readings in this period",
      //DetailScreen
      "value": "Value",
      "weightDescription": "Body weight is the total amount of mass in the human body",
      "heightDescription": "Human height is the distance from the bottom of the feet to the top of the head in a human body",
      "bmiDescription": "Body Mass Index (BMI) is a person's weight in kilograms (or pounds) divided by the square of height in meters (or feet)",
      "pressureDescription": "Blood pressure is the force of the blood pushing against the artery walls",
      "pulseDescription": "Heart rate, or pulse, is the number of times someone heart beats per minute",
      "spo2Description": "Oxygen saturation measures how much oxygen is carried by the hemoglobin in your blood",
      "temperatureDescription": "Body Temperature is the degree of internal heat of a person's body",
      "bfiDescription": "Body fat mass is the actual weight of fat in a person's body. It is found in the adipose tissue",
      "selectDateRange": "Select a Date Range",
      "last5": "Last 5",
      "lastYear": "Last year",
      "all": "All",
      "custom": "Customized",
      "startDate": "Start date",
      "endDate": "End date",
      "history": "History",
      "cancel": "Cancel",
      "ok": "Ok",
      "date": "Date",
      "hour": "Time",
      //Error Dialog set 2 dates
      "incorrectInterval": "Incorrect date format error.",
      //Management 
      "users": "Users",
      "days": "Days",
      "month": "Month",
      "year": "Year",
      "measureRegistration": "Machine Use",
      "noRegistryInterval": "There are no records in this period",
      "userEvolution": 'Users\' evolution',
      "lastMeasure": "last reading",
      "credit": "Credit",
      "lastUsersFromMachine": 'Last Users From Machine',
      "regiteredMeasures": "Registered Readings",
      "anonymousMeasures": "Anonymous Reading",
      "orgName": "Organization",
      "numMachines": 'Nº Machines',
      "initialCredit": 'Initial Credit',
      "orgData": "Organization Data",
      "city": "City",
      "province": "County",
      "country": "Country",
      "noCountrySelected": 'Select a country...',
      "postalcode": "Post code",
      "myOrg": "My Organization",
      "myMachines": "My Machines",
      "coordinates": "Coordinates",
      "machineData": "Machine Data",
      "model": "Model",
      "serial": "Serial number",
      "softwareVersion": "Software version",
      "lastConnectionDate": "Last connection date",
      "noMachine": "No machine selected",
      "noResults": "No results have been found",
      "search": "Search",
      "save": "Save changes",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "seeAll": "See All",
      "seeLast": 'See Last',
      "allUsers": "All users",
      "regDate": 'Registration Date',
      "searchUser": "Search User",
      "registerUser": "Do you want to add this user to the organization?",
      "accept": "Accept",
      "unregisterUsers": "Do you want to remove",
      "creditManagement": "Credit Management",
      "selectAction": "Select an action",
      "addCreditsToAll": "Add Credits to All",
      "setMinCredits": "Set Minimum Credits",
      "updateInitialCredit": "Update Initial Credit",
      "fullCredit": "Full Credit",
      "enterFullCredit": "Enter full credit",
      "creditsAddedSuccess": "Credits successfully added to all users.",
      "minCreditsSetSuccess": "Minimum credits set successfully.",
      "initialCreditUpdatedSuccess": "Initial credit updated successfully.",
      "operationError": "An error occurred while performing the operation.",
      "processing": "Processing...",
      "confirm": "Confirm",
      "BloodPres": 'Blood pressure',
      "IGP": '% Fat',
      "PrivacyPolicy": "Privacy Policy",
      "LegalNotice": "Legal Notice, Terms and Conditions",
      "CookiesPolicy": "Cookie Policy",
      "viewReports": "View Reports",
      "serverDate": "Server Date",
      "maxBloodPressure": "Max. Blood Pressure",
      "minBloodPressure": "Min. Blood Pressure",
      "credits": "Credits",
      "errorDownloadingMeasures": "Error downloading readings",
      "na": "N/A",
      "userDataAndMeasures": "User's Data and readings",
      "errorFindUsers": "Not user has been found",
      "creditRequired": "Insert credit",
      "seeMeasurements": "View Readings",
      "addCredit": "Add Credit",
      "downloadData": "Download Contacts",
      "desUser": "Unlink User",
      "errorDesUser": "The user could not be unlinked. Please try again.",
      "addCreditSuccess": "Credits updated successfully",
      "insertCreditModal": "Enter the new total credit value for the user:",
      "totalCredits": "New Total Credits",
      "setCredits": "Set Credits",
      "changesError": "Error saving changes...",
      "changesSuccesful": "Changes saved successfully",
      "errorRegUser": "Error likning the user. Please try again.",
      "responseAdminError": "Error receiving admin data",
      //
      "orgSelection": "Measures from organization",
      "machinesSelection": "Measures from machine",
      "selectMesureOrigin": "Select the type of measurement to search for.",
      "equipment": "Equipment",
      "largeDownload": "Downloading data... this may take several minutes",
      "timeZone": 'Time Zone',
      "oldPasswordPlaceholder": "Enter your current password",
      "invalidUserId": "Invalid User ID",
      "lastWeek": "Last Week",
      "lastMonth": "Last Month",
      "last90Days": "Last 90 Days",
      "setBirthDateAndSex": "Set Birth Date and Sex",
      "selectGender": "Select Gender",
      "errorOnSetUserInfo": "Please fill all fields correctly and accept the terms.",
      "internalCode": "Internal Code",
      "orgRegistrationDate": "Organization Registration Date",
      "disabledAccess": "Disabled Access",
      "vipUser": "VIP User",
      "yes": "Yes",
      "no": "No",
      "error": "Error",
      "addCreditsToAllDescription": "Add the specified value to all users in the organization.",
      "setMinCreditsDescription": "Increase the credit of all users to the specified value. It will not apply to users who have a higher credit than the specified value.",
      "updateInitialCreditDescription": "Set the specified value as the initial credit for the organization.",
      "edit": "Edit",
      "minPressureAbbr": "Min. Pressure",
      "maxPressureAbbr": "Max. Pressure",
      "addOrder": "Add Contact",
      "fecha": "Date",
      "cliente": "Customer",
      "direccion": "Address",
      "codPostal": "Postal Code",
      "poblacion": "City",
      "provincia": "Province",
      "pais": "Country",
      "telefono": "Phone",
      "email": "Email",
      "modelo": "Model",
      "observaciones": "Observations",
      "condiciones": "Conditions",
      "addOrderButton": "Add Contact",
      "customerData": "Customer Data",
      "searchAddress": "Search Address",
      "enterAddress": "Enter Address",
      "editOrder": "Edit Contact",
      "saveChangesButton": "Save Changes",
      "deleteOrder": "Delete Contact",
      "orderDetails": "Contact Details",
      "orderId": "Contact ID",
      "orderDate": "Contact Date",
      "orderAddress": "Contact Address",
      "orderPhone": "Contact Phone",
      "orderEmail": "Contact Email",
      "orderModel": "Contact Model",
      "orderObservations": "Contact Observations",
      "editOrderButton": "Edit Contact",
      "deleteOrderButton": "Delete Contact",
      "edit_columns": "Edit Columns",
      "vendedorEmail": "Seller"
    }
  },
  es: {
    translation: {
      //Login
      "welcome": "Bienvenido a Keito ",
      "eHealth": "Contactos",
      "intro": "Introduce tu N.º de usuario y tu contraseña",
      "userNumber": "N.º usuario",
      "userNumberPlaceholder": " N.º usuario",
      //
      "titlePassword": "Contraseña ",
      "password": "Contraseña",
      "passwordPlaceholder": "Tu contraseña",
      "rememberMe": "Recordarme",
      "login": "Acceder",
      "noAccount": "¿Aún no tienes una cuenta?",
      "authError": "Error de autenticación",
      //Register
      "signUp": "Registrarme",
      "title-register": "Registro en Keito",
      "intro-register": "Completa la información para crear una cuenta",
      "genderAtBirth": "Sexo al nacer",
      "male": "Hombre",
      "female": "Mujer",
      "dateOfBirth": "Fecha de nacimiento",
      "dateOfBirthPlaceholder": "Tu fecha de nacimiento",
      "enterPassword": "Introduce la contraseña",
      "newPasswordPlaceholder": "Tu nueva contraseña",
      "repeatPassword": "Repite la contraseña",
      "repeatPasswordPlaceholder": "Repite tu nueva contraseña",
      "acceptTerms": "Aceptar Condiciones y Términos de uso",
      "register": "Registrarse",
      "noOrders": "No hay contactos disponibles",
      "alreadyHaveAccount": "¿Ya tienes una cuenta?",
      "signIn": "Iniciar sesión",
      "titleMesurements": "Mis Medidas",
      "errorDate": "Selecciona tu fecha de nacimiento!",
      "errorAccept": "Debes aceptar las Condiciones y Términos de uso!",
      "errorPswIncorrect": "¡El formato de contraseña es incorrecto, el password debe coincidir con una longitud mínima de 5 caracteres!",
      //MainScreen
      "weight": "Peso",
      "weight-units": "Kg",
      "height": "Estatura",
      "height-units": "Cm",
      "bmi": "IMC",
      "bmi-units": "Kg/m",
      "pressure": "Presión Arterial",
      "pressure-units": "mmHg",
      "max-Sis": "Máxima Sistólica",
      "min-Dias": "Mínima Diastolica",
      "temperature": "Temperatura",
      "temperature-exp": "Temp.",
      "temperature-units": "ºC",
      "spo2": "SpO2",
      "spo2-units": "%",
      "pulse": "Pulso",
      "pulse-units": "ppm",
      "bfi": "% Grasa",
      "bfi-units": "%",
      "snormal": "Normal",
      "shigh": "Alta",
      "verylow": "Muy Bajo",
      "low": "Bajo",
      "mediumlow": "Medio Bajo",
      "mediumhigh": "Medio Alto",
      "high": "Alto",
      "veryhigh": "Muy Alto",
      "deletedAccount": "Esta cuenta ha sido eliminada.",
      "sureDelete": "¿Estás seguro que quieres eliminar la cuenta?",
      "errorDelete": "Error al eliminar la cuenta.",
      "delete": "Eliminar",
      "changePassword": "Cambiar Contraseña",
      "formatIncorrect": "Formato de la contraseña es incorrecto.",
      "passwordOk": "La contraseña ha sido actualizada correctamente.",
      "errorChangePassword": "Error al cambiar la contraseña.",
      "closeSession": "Cerrar sesión",
      "deleteUser": "Eliminar usuario",
      "alias": "Alias (Opcional)",
      "sureDeleteFromList": "¿Estás seguro de eliminar el usuario de la lista?",
      "addUser": "Añadir Usuario",
      "userExist": "El usuario ya existe en la lista",
      "default": "Predeterminado",
      "healthConnectNotAvailable": "El plugin de salud no está disponible. Por favor, ve a Play Store y descarga la aplicación Health Connect. Asegúrate de otorgar permisos a Google Fit y Keito eHealth.",
      "goToPlayStore": "Ir a Play Store",
      "connectWithAppsAndroid": "Conectar con Google Fit",
      "connectWithAppsIos": "Conectar con Apple Health",
      "disconnectFromApps": "Desconectar de aplicaciones...",
      //User birthdate ok
      "needinfo": "Por favor indica su sexo, fecha de nacimiento y contraseña definitiva",
      "errorBirthDate": "Debe seleccionar su sexo, fecha de nacimiento, contraseña y aceptar las Condiciones y Terminos de uso!",
      //Añadir o Registrar Usuario Dialog
      "addOrRegUser": "¿Desea añadir un usuario ya existente o registrar uno nuevo?",
      "userRegistered": "Usuario registrado",
      "regiterUser": "Registrar Usuario",
      "addChangeUser": "Añadir/Cambiar Usuario",
      "associateUser": "Asociar Usuario",
      //Pantalla QR
      "identifyTitle": "Identifícate en un equipo",
      "selectCodeType": "Selecciona",
      "codeType": "Tipo de código",
      "helpGifAltText": "Keito eHealth Gif de Ayuda",
      "insertCodeInstructions": "Inserta tu código en el equipo tal como se indica en el vídeo",
      "needHelp": "¿Necesitas Ayuda?",
      "contactUs": "Contáctanos",
      //Pantalla Last Ticket
      "lastTicket": "Último Ticket",
      "ticket": "Ticket",
      "equipmentNumber": "Equipo",
      "userId": "Usuario",
      "userAge": "Edad",
      "userSex": "Sexo",
      "measurements": "Medidas",
      "references": "Referencias",
      "title-bfi": 'Grasa corporal estimada',
      "%-bfi": "% Grasa",
      "windex-bfi": "Índice de agua",
      "fmass-bfi": "Masa de grasa",
      "fwmass-bfi": "Masa sin grasa",
      "wmass-bfi": "Masa de agua",
      "normalWeightBetween": "Peso normal entre",
      "and": "y",
      "yourBmiIs": "Su IMC es de",
      "shouldBeBetween": "Normalmente, debe estar entre",
      "bloodPressureAccordingToWHO": "Presión Arterial en mmHg según la OMS",
      "normalUntil": "Normal, Hasta",
      "highBetween": "Alta, Entre",
      "hypertension": "Hipertensión",
      "normalSpo2Value": "Valor Normal de Pulsioximetría",
      "normalSpo2Between": "Normal entre",
      "normalFatIndex": "Índice Normal de Grasa",
      "normalFatMass": "Masa Grasa Normal",
      "noMeasures": "Esta organización no tiene medidas registradas en este intervalo",
      "noMeasuresUser": "Este usuario no tiene medidas registradas en este intervalo",
      "noMeasuresInterval": "Esta organización no tiene medidas registradas en este intervalo",
      //DetailScreen
      "value": "Valor",
      "weightDescription": "El peso corporal es la cantidad de masa que tiene el cuerpo de un individuo",
      "heightDescription": "La estatura es la medida de una persona desde los pies a la cabeza",
      "bmiDescription": "El índice de masa corporal (IMC) es el peso de una persona en kilogramos dividido por el cuadrado de la estatura en metros",
      "pressureDescription": "La presión arterial es la fuerza de la sangre contra las paredes de los vasos sanguíneos",
      "pulseDescription": "La frecuencia cardíaca es el número de veces que se contrae el corazón durante un minuto (latidos por minuto)",
      "spo2Description": "La saturación de oxígeno (SpO2) mide el nivel de oxígeno en sangre",
      "temperatureDescription": "La temperatura corporal es una medida de la capacidad del organismo de generar y eliminar calor",
      "bfiDescription": "La masa grasa refleja el porcentaje de peso corporal constituido por el tejido adiposo",
      "selectDateRange": "Seleccione un Rango de Tiempo",
      "last5": "Últimas 5",
      "lastYear": "Último año",
      "all": "Todas",
      "custom": "Personalizado",
      "startDate": "Fecha Inicio",
      "endDate": "Fecha Fin",
      "history": "Historial",
      "cancel": "Cancelar",
      "ok": "Ok",
      "date": "Fecha",
      "hour": "Hora",
      //Error Dialog set 2 dates
      "incorrectInterval": "Error formato de fecha incorrecto.",
      //ManagementScreen
      "users": "Usuarios",
      "days": "Dias",
      "month": "Meses",
      "year": "Años",
      "measureRegistration": "Registro de Medidas",
      "noRegistryInterval": "Esta organización no tiene registro de uso en este intervalo de tiempo.",
      "noUserFound": "No se han encontrado usuarios",
      "userEvolution": 'Mediciones efectuadas',
      "lastMeasure": "Última Medida",
      "credit": "Crédito",
      "lastUsersFromMachine": 'Últimos usuarios del equipo',
      "regiteredMeasures": "Medidas Registradas",
      "anonymousMeasures": "Medidas Anónimas",
      "orgName": "Organización",
      "numMachines": 'Nº Equipos',
      "initialCredit": "Credito Inicial",
      "orgData": "Datos Organización",
      "city": "Poblacion",
      "province": "Provincia",
      "country": "Pais",
      "noCountrySelected": 'Seleccionar un pais...',
      "postalcode": "CP",
      "myOrg": "Mi Organización",
      "myMachines": "Mis Equipos",
      "coordinates": "Coordenadas",
      "machineData": "Datos del equipo",
      "model": "Modelo",
      "serial": "Nº Serie",
      "softwareVersion": "Versión software",
      "lastConnectionDate": "Fecha última conexión",
      "noMachine": "No hay equipo seleccionado",
      "noResults": "No se han encontrado resutados",
      "search": "Buscar",
      "save": "Guardar cambios",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "seeAll": "Ver Todos",
      "seeLast": 'Ver Ultimos',
      "allUsers": "Todos los Usuarios",
      "regDate": 'Fecha de Registro',
      "searchUser": "Buscar Usuario",
      "registerUser": "El usuario no pertenece a la organización ¿Desea registrar el usuario?",
      "accept": "Acceptar",
      "unregisterUsers": "¿Está seguro de que desea desasociar al usuario",
      "errorFindUsers": "Usuario no encontrado. Verifica el ID e inténtalo nuevamente.",
      "errorRegUser": "Error al registrar el usuario. Inténtelo nuevamente.",
      "creditManagement": "Gestión de Créditos",
      "selectAction": "Selecciona una acción",
      "addCreditsToAll": "Añadir Créditos a Todos",
      "setMinCredits": "Establecer Créditos Mínimos",
      "updateInitialCredit": "Actualizar Crédito Inicial",
      "fullCredit": "Crédito",
      "enterFullCredit": "Ingrese el crédito",
      "creditsAddedSuccess": "Créditos añadidos con éxito a todos los usuarios.",
      "minCreditsSetSuccess": "Créditos mínimos establecidos correctamente.",
      "initialCreditUpdatedSuccess": "Crédito inicial actualizado correctamente.",
      "operationError": "Ocurrió un error al realizar la operación.",
      "processing": "Procesando...",
      "confirm": "Confirmar",
      "BloodPres": 'Presión Arterial',
      "IGP": '% Grasa',
      "PrivacyPolicy": "Política de Privacidad",
      "LegalNotice": "Aviso Legal, Términos y Condiciones",
      "CookiesPolicy": "Política de Cookies",
      "viewReports": "Ver Informes",
      "serverDate": "Fecha del servidor",
      "maxBloodPressure": "Presión arterial máxima",
      "minBloodPressure": "Presión arterial mínima",
      "credits": "Créditos",
      "errorDownloadingMeasures": "Error al descargar las medidas",
      "na": "N/A",
      "userDataAndMeasures": "Datos del usuario y medidas",
      "changesSuccesful": "Cambios guardados exitosamente",
      "changesError": "Error al guardar...",
      "responseAdminError": "Error al recivir los datos de administrador",
      "seeMeasurements": "Ver Mediciones",
      "addCredit": "Añadir credito",
      "downloadData": "Descargar Contactos",
      "desUser": "Desasociar Usuario",
      "errorDesUser": "No se pudo desasociar el usuario. Inténtelo nuevamente.",
      "addCreditSuccess": "Creditos añadidos con éxito",
      "insertCreditModal": "Introduce el nuevo valor total de créditos para el usuario:",
      "totalCredits": "Nuevo total de créditos",
      "setCredits": "Establecer Créditos",
      "orgSelection": "Medidas de la organización",
      "machinesSelection": "Medidas del equipo",
      "selectMesureOrigin": "Seleccione el tipo de medida a buscar",
      "equipment": "Equipo",
      "largeDownload": "Descargando datos... puede tardar varios minutos",
      "timeZone": 'Zona Horaria',
      "oldPasswordPlaceholder": "Introduce tu contraseña actual",
      "invalidUserId": "ID de usuario no válido",
      "lastWeek": "Última Semana",
      "lastMonth": "Último Mes",
      "last90Days": "Últimos 90 Días",
      "setBirthDateAndSex": "Establecer Fecha de Nacimiento y Sexo",
      "selectGender": "Seleccionar Género",
      "errorOnSetUserInfo": "Por favor, complete todos los campos correctamente y acepte los términos.",
      "internalCode": "Código Interno",
      "orgRegistrationDate": "Fecha alta organización",
      "disabledAccess": "Acceso Deshabilitado",
      "vipUser": "Usuario VIP",
      "yes": "Sí",
      "no": "No",
      "error": "Error",
      "addCreditsToAllDescription": "Sumar el valor indicado a todos los usuarios de la organización.",
      "setMinCreditsDescription": "Aumentar el crédito de todos los usuarios hasta el valor indicado. No se aplicará a los usuarios que tengan un crédito superior al indicado.",
      "updateInitialCreditDescription": "Establecer valor indicado como crédito inicial de la organización.",
      "edit": "Editar",
      "minPressureAbbr": "Pres. Mín.",
      "maxPressureAbbr": "Pres. Máx.",
      "addOrder": "Añadir Contacto",
      "fecha": "Fecha",
      "cliente": "Cliente",
      "direccion": "Dirección",
      "codPostal": "Código Postal",
      "poblacion": "Población",
      "provincia": "Provincia",
      "pais": "País",
      "telefono": "Teléfono",
      "email": "Email",
      "modelo": "Modelo",
      "observaciones": "Observaciones",
      "condiciones": "Condiciones",
      "addOrderButton": "Añadir Contacto",
      "customerData": "Datos del Cliente",
      "searchAddress": "Buscar Dirección",
      "enterAddress": "Introducir Dirección",
      "editOrder": "Editar Contacto",
      "saveChangesButton": "Guardar Cambios",
      "deleteOrder": "Eliminar Contacto",
      "orderDetails": "Detalles del Contacto",
      "orderId": "ID del Contacto",
      "orderDate": "Fecha del Contacto",
      "orderAddress": "Dirección del Contacto",
      "orderPhone": "Teléfono del Contacto",
      "orderEmail": "Email del Contacto",
      "orderModel": "Modelo del Contacto",
      "orderObservations": "Observaciones del Contacto",
      "editOrderButton": "Editar Contacto",
      "deleteOrderButton": "Eliminar Contacto",
      "edit_columns": "Editar Columnas",
      "vendedorEmail": "Vendedor "
    }
  },
  it: {
    translation: {
      "welcome": "Benvenuto su Keito",
      "eHealth": "Contatti",
      "intro": "Inserisci il tuo nº utente e la tua password",
      "userNumber": "Nº utente",
      "userNumberPlaceholder": " Nº utente",
      //
      "titlePassword": "Password ",
      "password": "Password",
      "passwordPlaceholder": "La tua password",
      "rememberMe": "Ricordami",
      "login": "Log in",
      "noAccount": "Ancora non hai un account?",
      "authError": "Errore di autenticazione",
      //Register
      "signUp": "Registrati",
      "title-register": "Registro su Keito",
      "intro-register": "Completa l'inserimento dei dati per creare un account",
      "genderAtBirth": "Genere",
      "male": "Uomo",
      "female": "Donna",
      "dateOfBirth": "Data di nascita",
      "dateOfBirthPlaceholder": "La tua data di nascita",
      "enterPassword": "Inserisci la password",
      "newPasswordPlaceholder": "La tua nuova password",
      "repeatPassword": "Ripeti la password",
      "repeatPasswordPlaceholder": "Ripeti la tua nuova password",
      "acceptTerms": "Accettare Termini e Condizioni d'uso",
      "register": "Registrati",
      "noOrders": "Nessun contatto disponibile",
      "alreadyHaveAccount": "Hai già un account?",
      "signIn": "Inizia sessione",
      "titleMesurements": "Le mie misurazioni",
      "errorDate": "Inserisci la tua data di nascita",
      "errorAccept": "Occorre accettare i Termini e Condizioni d'uso",
      "errorPswIncorrect": "Il formato della password non è corretto. La password deve essere di almeno 5 carattari (lettere, numeri ecc.)",
      //MainScreen
      "weight": "Peso",
      "weight-units": "Kg",
      "height": "Altezza",
      "height-units": "Cm",
      "bmi": "BMI",
      "bmi-units": "Kg/m",
      "pressure": "Pressione Arteriosa",
      "pressure-units": "mmHg",
      "max-Sis": "Massima Sistolica",
      "min-Dias": "Minima Diastolica",
      "temperature": "Temperatura",
      "temperature-exp": "Temp.",
      "temperature-units": "ºC",
      "spo2": "SpO2",
      "spo2-units": "%",
      "pulse": "Polso",
      "pulse-units": "bpm",
      "bfi": "% Grasso",
      "bfi-units": "%",
      "snormal": "Normale",
      "shigh": "Alta",
      "verylow": "Molto Basso",
      "low": "Basso",
      "mediumlow": "Medio Basso",
      "mediumhigh": "Medio Alto",
      "high": "Alto",
      "veryhigh": "Molto Alto",
      "deletedAccount": "Questo account è stato eliminato.",
      "sureDelete": "Sei sicuro di voler eliminare l'account?",
      "errorDelete": "Errore durante l'eliminazione dell'account.",
      "delete": "Eliminare",
      "changePassword": "Cambiare Password",
      "formatIncorrect": "Il formato della password non è corretto.",
      "passwordOk": "La password è stata aggiornata correttamente.",
      "errorChangePassword": "Errore durante il cambio della password.",
      "closeSession": "Chiudere sessione",
      "deleteUser": "Eliminare account",
      "alias": "Alias (Opzionale)",
      "sureDeleteFromList": "Sei sicuro di voler eliminare l'utente dalla lista?",
      "addUser": "Aggiungi Utente",
      "userExist": "L'utente esiste già nell'elenco",
      "default": "Predeterminato",
      "healthConnectNotAvailable": "Il plugin di salute non è disponibile. Vai a Play Store e scarica l'app Health Connect. Assicurati di concedere i permessi a Google Fit e Keito eHealth.",
      "goToPlayStore": "Vai a Play Store",
      "connectWithAppsAndroid": "Connetti con Google Fit",
      "connectWithAppsIos": "Connetti con Apple Health",
      "disconnectFromApps": "Disconnetti dalle app...",
      //User birthdate ok
      "needinfo": "Si prega di indicare il sesso, la data di nascita e la password finale",
      "errorBirthDate": "Devi selezionare il tuo sesso, data di nascita, password e accettare le Condizioni e i Termini d'uso!",
      //Añadir o Registrar Usuario Dialog
      "addOrRegUser": "Vuoi aggiungere un utente esistente o registrarne uno nuovo?",
      "userRegistered": "Utente registrato",
      "regiterUser": "Registra utente",
      "addChangeUser": "Aggiungi/Cambia Utente",
      "associateUser": "Associare Utente",
      //Pantalla QR
      "identifyTitle": "Identificati su un dispositivo Keito",
      "selectCodeType": "Seleziona",
      "codeType": "Tipo di codice",
      "helpGifAltText": "Keito eHealth Gif di Aiuto",
      "insertCodeInstructions": "Scansiona il tuo codice così come indicato nel video",
      "needHelp": "Hai bisogno di Aiuto?",
      "contactUs": "Contattaci",
      //Pantalla Last Ticket
      "lastTicket": "Ultimo scontrino",
      "ticket": "Scontrino",
      "equipmentNumber": "Dispositivo",
      "userId": "Utente",
      "userAge": "Età",
      "userSex": "Genere",
      "measurements": "Misurazioni",
      "references": "Referenze",
      "title-bfi": 'Grasso corporeo stimato',
      "%-bfi": "% Grasso",
      "windex-bfi": "Indice acqua corporea",
      "fmass-bfi": "Massa de grassa",
      "fwmass-bfi": "Massa magra",
      "wmass-bfi": "Acqua corporea",
      "normalWeightBetween": "Peso ideale compreso tra",
      "and": "e",
      "yourBmiIs": "Il tuo BMI è",
      "shouldBeBetween": "Deve essere compreso tra",
      "bloodPressureAccordingToWHO": "Pressione Arteriosa in mmHg secondo la OMS",
      "normalUntil": "Ideale, Fino",
      "highBetween": "Alta, Tra",
      "hypertension": "Ipertensione",
      "normalSpo2Value": "Valore ideale della Pulsossimetria",
      "normalSpo2Between": "Ideale tra",
      "normalFatIndex": "Indice Ideale di Grasso",
      "normalFatMass": "Massa Grassa Ideale",
      "noMeasures": "Non ci sono misurazioni in questo account",
      "noMeasuresUser": "Questo utente non ha misurazioni registrate in questo intervallo",
      "noMeasuresInterval": "Questa organizzazione non ha misurazioni registrate in questo intervallo",
      //DetailScreen
      "value": "Valore",
      "weightDescription": "Il peso corporeo è la quantità totale di massa presente nel corpo umano",
      "heightDescription": "L'altezza è la misura di lunghezza del corpo umano rilevata tra la pianta dei piedi e il vertex (punto più alto della testa)",
      "bmiDescription": "L'indice di massa corporea (abbreviato IMC o BMI, dall'inglese body mass index) è un dato biometrico, espresso come rapporto tra peso e quadrato dell'altezza di un individuo",
      "pressureDescription": "La pressione arteriosa è quella forza con cui il sangue viene spinto attraverso i vasi sanguigni",
      "pulseDescription": "La frequenza cardiaca è la velocità delle contrazioni o pulsazioni del cuore misurate dal numero di battiti al minuto (bpm)",
      "spo2Description": "La saturazione di ossigeno nel sangue (SpO2) è una stima della quantità di ossigeno nel sangue. È la percentuale di emoglobina ossigenata rispetto alla quantità totale di emoglobina nel sangue (emoglobina ossigenata e non)",
      "temperatureDescription": "La temperatura corporea misura la capacità dell'organismo di produrre ed emettere calore, attività necessaria per le funzioni metaboliche vitali",
      "bfiDescription": "La massa grassa è la quantità totale dei grassi presenti nel corpo umano.",
      "selectDateRange": "Seleziona un rango",
      "last5": "Ultime 5",
      "lastYear": "Ultimo anno",
      "all": "Tutte",
      "custom": "Personalizzato",
      "startDate": "Data inizio",
      "endDate": "Data fine",
      "history": "Storico",
      "cancel": "Annulla",
      "ok": "Ok",
      "date": "Data",
      "hour": "Ora",
      //Error Dialog set 2 dates
      "incorrectInterval": "Errore nel formato della data non corretto.",
      //Management
      "BloodPres": "Pressione arteriosa",
      "CookiesPolicy": "Politica sui Cookie",
      "IGP": "% Grasso",
      "LegalNotice": "Avviso Legale, Termini e Condizioni",
      "PrivacyPolicy": "Politica sulla Privacy",
      "accept": "Accetta",
      "addCredit": "Aggiungi Credito",
      "addCreditSuccess": "Crediti aggiornati con successo",
      "addCreditsToAll": "Aggiungi crediti a tutti",
      "allUsers": "Tutti gli utenti",
      "anonymousMeasures": "Misurazioni anonime",
      "city": "Città",
      "confirm": "Conferma",
      "coordinates": "Coordinate",
      "country": "Paese",
      "credit": "Credito",
      "creditManagement": "Gestione dei Crediti",
      "creditRequired": "Inserisci il credito",
      "credits": "Crediti",
      "creditsAddedSuccess": "Crediti aggiunti con successo a tutti gli utenti.",
      "days": "Giorni",
      "downloadData": "scaricare contatto",
      "enterFullCredit": "Inserisci il credito completo",
      "errorDesUser": "Impossibile scollegare l'utente. Riprova.",
      "errorDownloadingMeasures": "Errore durante il download delle misurazioni",
      "errorFindUsers": "Utente non trovato. Verifica l'ID e riprova.",
      "fullCredit": "Credito Completo",
      "initialCredit": "Credito Iniziale",
      "initialCreditUpdatedSuccess": "Credito iniziale aggiornato con successo.",
      "insertCreditModal": "Inserisci il nuovo valore totale di credito per l'utente:",
      "lastConnectionDate": "Data dell'ultima connessione",
      "lastMeasure": "Ultima Misurazione",
      "lastUsersFromMachine": "Ultimi utenti dal dispositivo",
      "latitude": "Latitudine",
      "longitude": "Longitudine",
      "machineData": "Dati Dispositio",
      "maxBloodPressure": "Pressione arteriosa massima",
      "measureRegistration": "Registrazione Misurazioni",
      "minBloodPressure": "Pressione arteriosa minima",
      "minCreditsSetSuccess": "Crediti minimi impostati con successo.",
      "model": "Modello",
      "month": "Mese",
      "myMachines": "I miei dispositivi",
      "myOrg": "La Mia Organizzazione",
      "na": "N/D",
      "noCountrySelected": "Seleziona un paese...",
      "noMachine": "Nessun dispositivo selezionato",
      "noRegistryInterval": "Nessun registro in questo periodo",
      "noResults": "Nessun risultato trovato",
      "numMachines": "Numero di Dispositivi",
      "operationError": "Si è verificato un errore durante l'operazione.",
      "orgData": "Dati dell'Organizzazione",
      "orgName": "Organizzazione",
      "postalcode": "CAP",
      "processing": "Elaborazione...",
      "province": "Provincia",
      "regDate": "Data di Registrazione",
      "registerUser": "Vuoi registrare l'utente?",
      "regiteredMeasures": "Misurazioni Registrate",
      "save": "Salva Modifiche",
      "search": "Cerca",
      "searchUser": "Cerca Utente",
      "seeAll": "Vedi Tutti",
      "seeLast": "Vedi Ultimi",
      "seeMeasurements": "Visualizza Misurazioni",
      "selectAction": "Seleziona un'Azione",
      "serial": "Numero di Serie",
      "serverDate": "Data del Server",
      "setCredits": "Imposta Crediti",
      "setMinCredits": "Imposta Crediti Minimi",
      "softwareVersion": "Versione Software",
      "totalCredits": "Nuovo Totale Crediti",
      "unregisterUsers": "Sei sicuro di voler disassociare l'utente?",
      "updateInitialCredit": "Aggiorna Credito Iniziale",
      "userDataAndMeasures": "Dati Utente e Misurazioni",
      "userEvolution": "Evoluzione Utente",
      "users": "Utenti",
      "viewReports": "Visualizza Rendiconti",
      "year": "Anno",
      //
      "orgSelection": "Misure dall'organizzazione",
      "machinesSelection": "Misure dalla macchina",
      "selectMesureOrigin": "Seleziona il tipo di misurazione da cercare.",
      "equipment": "Attrezzatura",
      "largeDownload": "Download dei dati in corso... potrebbe richiedere diversi minuti",
      "timeZone": 'Fuso orario',
      "oldPasswordPlaceholder": "Inserisci la tua password attuale",
      "invalidUserId": "ID utente non valido",
      "lastWeek": "Ultima Settimana",
      "lastMonth": "Ultimo Mese",
      "last90Days": "Ultimi 90 Giorni",
      "setBirthDateAndSex": "Imposta Data di Nascita e Sesso",
      "selectGender": "Seleziona Genere",
      "errorOnSetUserInfo": "Si prega di compilare tutti i campi correttamente e accettare i termini.",
      "internalCode": "Codice Interno",
      "orgRegistrationDate": "Data di Registrazione nell'Organizzazione",
      "disabledAccess": "Accesso Disabilitato",
      "vipUser": "Utente VIP",
      "yes": "Sì",
      "no": "No",
      "error": "Errore",
      "addCreditsToAllDescription": "Aggiungi il valore specificato a tutti gli utenti dell'organizzazione.",
      "setMinCreditsDescription": "Aumenta il credito di tutti gli utenti al valore specificato. Non si applicherà agli utenti che hanno un credito superiore al valore specificato.",
      "updateInitialCreditDescription": "Imposta il valore specificato come credito iniziale per l'organizzazione.",
      "edit": "Modifica",
      "minPressureAbbr": "Press. Min.",
      "maxPressureAbbr": "Press. Max.",
      "addOrder": "Aggiungi Contatto",
      "fecha": "Data",
      "cliente": "Cliente",
      "direccion": "Indirizzo",
      "codPostal": "Codice Postale",
      "poblacion": "Città",
      "provincia": "Provincia",
      "pais": "Paese",
      "telefono": "Telefono",
      "email": "Email",
      "modelo": "Modello",
      "observaciones": "Osservazioni",
      "condiciones": "Condizioni",
      "addOrderButton": "Aggiungi Contatto",
      "customerData": "Dati del Cliente",
      "searchAddress": "Cerca Indirizzo",
      "enterAddress": "Inserisci Indirizzo",
      "editOrder": "Modifica Contatto",
      "saveChangesButton": "Salva Modifiche",
      "deleteOrder": "Elimina Contatto",
      "orderDetails": "Dettagli del Contatto",
      "orderId": "ID del Contatto",
      "orderDate": "Data del Contatto",
      "orderAddress": "Indirizzo del Contatto",
      "orderPhone": "Telefono del Contatto",
      "orderEmail": "Email del Contatto",
      "orderModel": "Modello del Contatto",
      "orderObservations": "Osservazioni del Contatto",
      "editOrderButton": "Modifica Contatto",
      "deleteOrderButton": "Elimina Contatto",
      "edit_columns": "Modifica Colonne"
    }
  },
  ca: {
    translation: {
      //Login
      "welcome": "Benvingut a Keito ",
      "eHealth": "Contactes",
      "intro": "Introdueix el teu Núm. d'usuari i la teva contrasenya",
      "userNumber": "Núm. Usuari",
      "userNumberPlaceholder": "El teu núm. d'usuari",
      //
      "titlePassword": "Contrasenya",
      "password": "Contrasenya",
      "passwordPlaceholder": "La teva contrasenya",
      "rememberMe": "Recordar-me",
      "login": "Accedir",
      "noAccount": "Encara no tens un compte?",
      "authError": "Error d’autenticació",
      //Register
      "signUp": "Registrar-me",
      "title-register": "Registre a Keito",
      "intro-register": "Completa la informació per crear un compte",
      "genderAtBirth": "Sexe en néixer",
      "male": "Home",
      "female": "Dona",
      "dateOfBirth": "Data de naixement",
      "dateOfBirthPlaceholder": "La teva data de naixement",
      "enterPassword": "Introduïu la contrasenya",
      "newPasswordPlaceholder": "La tua nova contrasenya",
      "repeatPassword": "Repeteix la contrasenya",
      "repeatPasswordPlaceholder": "Repeteix la teva contrasenya nova",
      "acceptTerms": "Acceptar Condicions i Termes d'ús",
      "register": "Registrar-se",
      "noOrders": "No hi ha contactes disponibles",
      "alreadyHaveAccount": "Ja tens un compte?",
      "signIn": "Iniciar Sessió",
      "titleMesurements": "Mesures",
      "errorDate": "Selecciona la data de naixement!",
      "errorAccept": "Has d'acceptar les condicions i els termes d'ús!",
      "errorPswIncorrect": "Format de contrasenya incorrecte, els passwords han de coincidir amb una longitud mínima de 5 caràcters!",
      //MainScreen
      "weight": "Pes",
      "weight-units": "Kg",
      "height": "Estatura",
      "height-units": "Cm",
      "bmi": "IMC",
      "bmi-units": "Kg/m",
      "pressure": "Pressió Arterial",
      "pressure-units": "mmHg",
      "max-Sis": "Màxima Sistòlica",
      "min-Dias": "Mínima Diastòlica",
      "temperature": "Temperatura",
      "temperature-exp": "Temp.",
      "temperature-units": "ºC",
      "spo2": "SPO2",
      "spo2-units": "%",
      "pulse": "Pols",
      "pulse-units": "bpm",
      "bfi": "% Greix",
      "bfi-units": "%",
      "snormal": "Normal",
      "shigh": "Alt",
      "verylow": "Molt baix",
      "low": "Baix",
      "mediumlow": "Mitjà Baix",
      "mediumhigh": "Mitjà Alt",
      "high": "Alt",
      "veryhigh": "Molt Alt",
      "deletedAccount": "Aquest compte ha estat eliminat.",
      "sureDelete": "Esteu segur d'eliminar el compte?",
      "errorDelete": "Error en eliminar el compte.",
      "delete": "Eliminar",
      "changePassword": "Canviar Contrasenya",
      "formatIncorrect": "Format de contrasenya incorrecte.",
      "passwordOk": "La contrasenya s'ha actualitzat correctament.",
      "errorChangePassword": "Error en canviar la contrasenya.",
      "closeSession": "Tancar sessió",
      "deleteUser": "Eliminar usuari",
      "alias": "Àlies (Opcional)",
      "sureDeleteFromList": "Estàs segur d'eliminar l'usuari de la llista?",
      "addUser": "Afegir Usuari",
      "userExist": "L'usuari ja existeix a la llista",
      "default": "Per defecte",
      "healthConnectNotAvailable": "El plugin de salut no està disponible. Si us plau, ves a Play Store i descarrega l'aplicació Health Connect. Assegura't d'atorgar permisos a Google Fit i Keito eHealth.",
      "goToPlayStore": "Anar a Play Store",
      "connectWithAppsAndroid": "Connectar amb Google Fit",
      "connectWithAppsIos": "Connectar amb Apple Health",
      "disconnectFromApps": "Desconnectar d'aplicacions...",
      //User birthdate ok
      "needinfo": "Si us plau, indica el teu sexe, data de naixement i contrasenya definitiva",
      "errorBirthDate": "Has de seleccionar el seu sexe, data de naixement, contrasenya i acceptar les Condicions i Termes d'ús!",
      //Añadir o Registrar Usuario Dialog
      "addOrRegUser": "Vol afegir un usuari ja existent o registrar-ne un de nou?",
      "userRegistered": "Usuari registrat",
      "regiterUser": "Registrar usuari",
      "addChangeUser": "Afegir/Canviar Usuari",
      "associateUser": "Associar Usuari",
      //Pantalla QR
      "identifyTitle": "Identifica't en un equip",
      "selectCodeType": "Selecciona",
      "codeType": "tipus de codi",
      "helpGifAltText": "Keito eHealth Gif de Ayuda",
      "insertCodeInstructions": "Inseriu el vostre codi a l'ordinador tal com s'indica al vídeo",
      "needHelp": "Necessites Ajuda?",
      "contactUs": "Contacta'ns",
      //Pantalla Last Ticket
      "lastTicket": "Darrer Tiquet",
      "ticket": "Tiquet",
      "equipmentNumber": "Equip",
      "userId": "Usuari",
      "userAge": "Edat",
      "userSex": "Sexe",
      "measurements": "Mesures",
      "references": "Referències",
      "title-bfi": 'Greix corporal estimat',
      "%-bfi": "% Greix",
      "windex-bfi": "Índex d'aigua",
      "fmass-bfi": "Massa de greix",
      "fwmass-bfi": "Massa sense greix",
      "wmass-bfi": "Massa d'aigua",
      "normalWeightBetween": "Pes normal entre",
      "and": "i",
      "yourBmiIs": "El seu IMC és de",
      "shouldBeBetween": "Normalment, ha d'estar entre",
      "bloodPressureAccordingToWHO": "Pressió Arterial a mmHg Segons l'OMS",
      "normalUntil": "Normal, fins",
      "highBetween": "Alt, entre",
      "hypertension": "Hipertensió",
      "normalSpo2Value": "Valor Normal de Pulsioximetria",
      "normalSpo2Between": "Normal entre",
      "normalFatIndex": "Índex Normal de Greix",
      "normalFatMass": "Massa Greix Normal",
      "noMeasures": "Aquest usuari no té mesures",
      "noMeasuresUser": "Aquest usuari no té mesures registrades en aquest interval",
      "noMeasuresInterval": "Aquesta organització no té mesures registrades en aquest interval",
      //DetailScreen
      "value": "Valor",
      "weightDescription": "El pes corporal és la quantitat de massa que té el cos d'un individu",
      "heightDescription": "L'alçada és la mesura d'una persona des dels peus fins al cap",
      "bmiDescription": "L'índex de massa corporal (IMC) és el pes d'una persona en quilograms dividit pel quadrat de l'alçada en metres",
      "pressureDescription": "La pressió arterial és la força de la sang contra les parets dels vasos sanguinis",
      "pulseDescription": "La freqüència cardíaca és el nombre de vegades que es contrau el cor durant un minut (bategades per minut)",
      "spo2Description": "La saturació d'oxigen (SpO2) mesura el nivell d'oxigen en sang",
      "temperatureDescription": "La temperatura corporal és una mesura de la capacitat de l'organisme de generar i eliminar calor",
      "bfiDescription": "La massa greix reflecteix el percentatge de pes corporal constituït pel teixit adipós",
      "selectDateRange": "Seleccioneu un Rang de Temps",
      "last5": "Últimes 5",
      "lastYear": "Últim any",
      "all": "Totes",
      "custom": "Personalitzat",
      "startDate": "Data Inici",
      "endDate": "Data Fi",
      "history": "Historial",
      "cancel": "Cancel·lar",
      "ok": "D'acord",
      "date": "Data",
      "hour": "Hora",
      //Error Dialog set 2 dates
      "incorrectInterval": "Error format de data incorrecte.",
      //Management
      "BloodPres": "Pressió arterial",
      "CookiesPolicy": "Política de cookies",
      "IGP": "% Greix",
      "LegalNotice": "Avís Legal, Termes i Condicions",
      "PrivacyPolicy": "Política de Privacitat",
      "accept": "Acceptar",
      "addCredit": "Afegir Crèdit",
      "addCreditSuccess": "Crèdits actualitzats amb èxit",
      "addCreditsToAll": "Afegir crèdits a tots",
      "allUsers": "Tots els usuaris",
      "anonymousMeasures": "Mesures anònimes",
      "city": "Ciutat",
      "confirm": "Confirmar",
      "coordinates": "Coordenades",
      "country": "País",
      "credit": "Crèdit",
      "creditManagement": "Gestió de Crèdits",
      "creditRequired": "Introdueix el crèdit",
      "credits": "Crèdits",
      "creditsAddedSuccess": "Crèdits afegits amb èxit a tots els usuaris.",
      "days": "Dies",
      "desUser": "Desvincular Usuari",
      "downloadData": "Descarregar contactes",
      "enterFullCredit": "Introdueix el crèdit complet",
      "errorDesUser": "No s'ha pogut desvincular l'usuari. Torna-ho a intentar.",
      "errorDownloadingMeasures": "Error en descarregar les mesures",
      "errorFindUsers": "Usuari no trobat. Verifica l'ID i torna-ho a intentar.",
      "fullCredit": "Crèdit Complet",
      "initialCredit": "Crèdit Inicial",
      "initialCreditUpdatedSuccess": "Crèdit inicial actualitzat amb èxit.",
      "insertCreditModal": "Introdueix el nou valor total de crèdits per a l'usuari:",
      "lastConnectionDate": "Data de l'última connexió",
      "lastMeasure": "Última Mesura",
      "lastUsersFromMachine": "Últims usuaris del equip",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "machineData": "Dades del equip",
      "maxBloodPressure": "Pressió arterial màxima",
      "measureRegistration": "Registre de Mesures",
      "minBloodPressure": "Pressió arterial mínima",
      "minCreditsSetSuccess": "Crèdits mínims establerts amb èxit.",
      "model": "Model",
      "month": "Mes",
      "myMachines": "Els meus equips",
      "myOrg": "La Meva Organització",
      "na": "N/D",
      "noCountrySelected": "Selecciona un país...",
      "noMachine": "No hi ha cap equip seleccionat",
      "noRegistryInterval": "L'organització no te registres en aquest període",
      "noResults": "No s'han trobat resultats",
      "numMachines": "Nombre de Equips",
      "operationError": "S'ha produït un error en realitzar l'operació.",
      "orgData": "Dades de l'Organització",
      "orgName": "Organització",
      "postalcode": "Codi Postal",
      "processing": "Processant...",
      "province": "Província",
      "regDate": "Data de Registre",
      "registerUser": "Vols registrar l'usuari?",
      "regiteredMeasures": "Mesures Registrades",
      "save": "Desa Canvis",
      "search": "Cercar",
      "searchUser": "Cercar Usuari",
      "seeAll": "Veure Tots",
      "seeLast": "Veure Últims",
      "seeMeasurements": "Veure Mesures",
      "selectAction": "Selecciona una Acció",
      "serial": "Número de Sèrie",
      "serverDate": "Data del Servidor",
      "setCredits": "Establir Crèdits",
      "setMinCredits": "Establir Crèdits Mínims",
      "softwareVersion": "Versió del Programari",
      "totalCredits": "Nou Total de Crèdits",
      "unregisterUsers": "Estàs segur que vols desvincular l'usuari?",
      "updateInitialCredit": "Actualitzar Crèdit Inicial",
      "userDataAndMeasures": "Dades de l'Usuari i Mesures",
      "userEvolution": "Evolució de l'Usuari",
      "users": "Usuaris",
      "viewReports": "Veure Informes",
      "year": "Any",
      //
      "orgSelection": "Mesures de l'organització",
      "machinesSelection": "Mesures del equip",
      "selectMesureOrigin": "Selecciona el tipus de mesura a cercar.",
      "equipment": "Equipament",
      "largeDownload": "Baixant dades... això pot trigar uns minuts",
      "timeZone": 'Zona horaria',
      "oldPasswordPlaceholder": "Introdueix la teva contrasenya actual",
      "invalidUserId": "ID d'usuari no vàlid",
      "lastWeek": "Última Setmana",
      "lastMonth": "Últim Mes",
      "last90Days": "Últims 90 Dies",
      "setBirthDateAndSex": "Establir Data de Naixement i Sexe",
      "selectGender": "Seleccionar Gènere",
      "errorOnSetUserInfo": "Si us plau, ompliu tots els camps correctament i accepteu els termes.",
      "internalCode": "Codi Intern",
      "orgRegistrationDate": "Data de Registre a l'Organització",
      "disabledAccess": "Accés Deshabilitat",
      "vipUser": "Usuari VIP",
      "yes": "Sí",
      "no": "No",
      "error": "Error",
      "addCreditsToAllDescription": "Suma el valor indicat a tots els usuaris de l'organització.",
      "setMinCreditsDescription": "Augmenta el crèdit de tots els usuaris fins al valor indicat. No s'aplicarà als usuaris que tinguin un crèdit superior al valor indicat.",
      "updateInitialCreditDescription": "Estableix el valor indicat com a crèdit inicial de l'organització.",
      "edit": "Editar",
      "minPressureAbbr": "Pres. Mín.",
      "maxPressureAbbr": "Pres. Máx.",
      "addOrder": "Afegir Contacte",
      "fecha": "Data",
      "cliente": "Client",
      "direccion": "Adreça",
      "codPostal": "Codi Postal",
      "poblacion": "Població",
      "provincia": "Província",
      "pais": "País",
      "telefono": "Telèfon",
      "email": "Email",
      "modelo": "Model",
      "observaciones": "Observacions",
      "condiciones": "Condicions",
      "addOrderButton": "Afegir Contacte",
      "customerData": "Dades del Client",
      "searchAddress": "Cercar Adreça",
      "enterAddress": "Introduir Adreça",
      "editOrder": "Editar Contacte",
      "saveChangesButton": "Desar Canvis",
      "deleteOrder": "Eliminar Contacte",
      "orderDetails": "Detalls del Contacte",
      "orderId": "ID del Contacte",
      "orderDate": "Data del Contacte",
      "orderAddress": "Adreça del Contacte",
      "orderPhone": "Telèfon del Contacte",
      "orderEmail": "Email del Contacte",
      "orderModel": "Model del Contacte",
      "orderObservations": "Observacions del Contacte",
      "editOrderButton": "Editar Contacte",
      "deleteOrderButton": "Eliminar Contacte",
      "edit_columns": "Editar Columnes"
    }
  },
  fr: {
    translation: {
      //Login
      "welcome": "Bienvenue à Keito ",
      "eHealth": "Contacts",
      "intro": "Introduisez votre N.º d'usager et votre mot de passe",
      "userNumber": "N.º d'usager",
      "userNumberPlaceholder": " N.º d'usager",
      //
      "titlePassword": "Contraseña",
      "password": "Mot de passe",
      "passwordPlaceholder": "Votre mot de passe",
      "rememberMe": "Sauvegarder",
      "login": "Accéder",
      "noAccount": "¿Vous n'avez pas encore de compte?",
      "authError": "Erreur d'identification",
      //Register
      "signUp": "M'inscrire",
      "title-register": "Registre dans Keito",
      "intro-register": "Remplissez l'information pour créer un compte",
      "genderAtBirth": "Sexe de naissance",
      "male": "Homme",
      "female": "Femme",
      "dateOfBirth": "Date de naissance",
      "dateOfBirthPlaceholder": "Votre date de naissance",
      "enterPassword": "Introduisez le mot de passe",
      "newPasswordPlaceholder": "Votre nouveau mot de passe",
      "repeatPassword": "Confirmez le mot de passe",
      "repeatPasswordPlaceholder": "Confirmez votre nouveau mot de passe",
      "acceptTerms": "Accépter les Conditions et Termes d'usage",
      "register": "S'inscrire",
      "noOrders": "Aucun contact disponible",
      "alreadyHaveAccount": "¿Vous avez déjà un compte?",
      "signIn": "Connection",
      "titleMesurements": "Mes mesures",
      "errorDate": "Sélectionner votre date de naissance!",
      "errorAccept": "Vous devez accepter les Conditions et Termes d'usage!",
      "errorPswIncorrect": "¡Le format du mot de passe est incorrecte, le mot de passe doit avoir une longueur minimale de 5 caractères!",
      //MainScreen
      "weight": "Poids",
      "weight-units": "Kg",
      "height": "Taille",
      "height-units": "Cm",
      "bmi": "IMC",
      "bmi-units": "Kg/m",
      "pressure": "Tension artérielle",
      "pressure-units": "mmHg",
      "max-Sis": "Maximale Systolique",
      "min-Dias": "Minimale Diastolique",
      "temperature": "Température",
      "temperature-exp": "Temp.",
      "temperature-units": "ºC",
      "spo2": "SpO2",
      "spo2-units": "%",
      "pulse": "Pouls",
      "pulse-units": "ppm",
      "bfi": "% Graisse",
      "bfi-units": "%",
      "snormal": "Normal",
      "shigh": "Haute",
      "verylow": "Très basse",
      "low": "Basse",
      "mediumlow": "Moyen faible",
      "mediumhigh": "Moyen haut",
      "high": "Haut",
      "veryhigh": "Très Haut",
      "deletedAccount": "Ce compte a été éliminé.",
      "sureDelete": "¿Vous êtes sûr de vouloir éliminer le compte?",
      "errorDelete": "Erreur lors de la suppression du compte.",
      "delete": "Eliminer",
      "changePassword": "Changer le mot de passe",
      "formatIncorrect": "Le format du mot de passe est incorrecte.",
      "passwordOk": "Le mot de passe a été mis à jour avec succès.",
      "errorChangePassword": "Erreur lors du changement de mot de passe.",
      "closeSession": "Déconnection",
      "deleteUser": "Eliminer l'usager",
      "alias": "Alias (Facultatif)",
      "sureDeleteFromList": "Êtes-vous sûr de vouloir supprimer l'utilisateur de la liste?",
      "addUser": "Ajouter un utilisateur",
      "userExist": "L'utilisateur existe déjà dans la liste",
      "default": "Prédéterminé",
      "healthConnectNotAvailable": "Le plugin de santé n'est pas disponible. Veuillez aller sur Play Store et télécharger l'application Health Connect. Assurez-vous de donner les permissions à Google Fit et Keito eHealth.",
      "goToPlayStore": "Aller à Play Store",
      "connectWithAppsAndroid": "Se connecter à Google Fit",
      "connectWithAppsIos": "Se connecter à Apple Health",
      "disconnectFromApps": "Déconnecter des applications...",
      //User birthdate ok
      "needinfo": "Veuillez indiquer votre sexe, votre date de naissance et votre mot de passe final",
      "errorBirthDate": "Vous devez sélectionner votre sexe, votre date de naissance, votre mot de passe et accepter les Conditions et Conditions d'utilisation!",
      //Añadir o Registrar Usuario Dialog
      "addOrRegUser": "Voulez-vous ajouter un utilisateur existant ou enregistrer un nouveau?",
      "userRegistered": "Utilisateur enregistré",
      "regiterUser": "Enregistrer l'utilisateur",
      "addChangeUser": "Ajouter/Changer d'utilisateur",
      "associateUser": "Associer Utilisateur",
      //Pantalla QR
      "identifyTitle": "Identifiez-vous sur un équipement",
      "selectCodeType": "Sélectionner",
      "codeType": "Type de code",
      "helpGifAltText": "Keito eHealth Gif d'Aide",
      "insertCodeInstructions": "Insérez votre code dans l'appareil comme indiqué dans la vidéo",
      "needHelp": "¿Vous avez besoin d'aide?",
      "contactUs": "Contactez-nous",
      //Pantalla Last Ticket
      "lastTicket": "Dernier ticket",
      "ticket": "Ticket",
      "equipmentNumber": "Equipement",
      "userId": "Usager",
      "userAge": "Âge",
      "userSex": "Sexe",
      "measurements": "Mesures",
      "references": "Références",
      "title-bfi": 'Graisse corporelle estimée',
      "%-bfi": "% Graisse",
      "windex-bfi": "Indice d'eau",
      "fmass-bfi": "Masse de graisse",
      "fwmass-bfi": "Masse sans graisse",
      "wmass-bfi": "Masse d'eau",
      "normalWeightBetween": "Poids normal entre",
      "and": "et",
      "yourBmiIs": "Votre IMC est de",
      "shouldBeBetween": "Normalment, il doit être entre",
      "bloodPressureAccordingToWHO": "Tension Artérielle en mmHg selon l'OMS",
      "normalUntil": "Normale, Jusqu'à",
      "highBetween": "Haute, Entre",
      "hypertension": "Hypertension",
      "normalSpo2Value": "Valeur Normale d'Oxymétrie de pouls",
      "normalSpo2Between": "Normale entre",
      "normalFatIndex": "Indice Normal de Graisse",
      "normalFatMass": "Masse Grasse Normale",
      "noMeasures": "Cet usager n'a pas de mesures",
      "noMeasuresUser": "Cet utilisateur n'a pas de mesures enregistrées dans cet intervalle",
      "noMeasuresInterval": "Cette organisation n'a pas de mesures enregistrées dans cet intervalle",
      //DetailScreen
      "value": "Value",
      "weightDescription": "Le poids corporel est la quantité de masse qu'a le corps d'un individu",
      "heightDescription": "La taille est la mesure d'une personne des pieds à la tête",
      "bmiDescription": "L'indice de Masse Corporelle (IMC) mesure la teneur en graisse corporelle par rapport à la taille et au poids",
      "pressureDescription": "La tension artérielle est la force du sang contre les parois des vaisseaux sanguins",
      "pulseDescription": "La fréquence cardiaque est le nombre de fois que le coeur se contracte en une minute (battements par minute)",
      "spo2Description": "La saturation d'oxygène (SpO2) mesure le niveau d'oxygène dans le sang",
      "temperatureDescription": "La température corporelle est la mesure de la capacité de l'organisme de générer et éliminer la chaleur",
      "bfiDescription": "La masse grasse refléte le pourcentage de poids corporel formé par le tissu adipeux",
      "selectDateRange": " Sélectionnez une échelle de Temps",
      "last5": "5 dernières",
      "lastYear": "Dernière année",
      "all": "Toutes",
      "custom": "Personnalisé",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "history": "Historique",
      "cancel": "Annuler",
      "ok": "Ok",
      "date": "Date",
      "hour": "Heure",
      //Error Dialog set 2 dates
      "incorrectInterval": "Erreur de format de date incorrecte.",
      //Management
      "BloodPres": "Pression artérielle",
      "CookiesPolicy": "Politique de Cookies",
      "IGP": "% Graisse",
      "LegalNotice": "Mentions Légales, Termes et Conditions",
      "PrivacyPolicy": "Politique de Confidentialité",
      "accept": "Accepter",
      "addCredit": "Ajouter Crédit",
      "addCreditSuccess": "Crédits mis à jour avec succès",
      "addCreditsToAll": "Ajouter des crédits à tous",
      "allUsers": "Tous les utilisateurs",
      "anonymousMeasures": "Mesures anonymes",
      "city": "Ville",
      "confirm": "Confirmer",
      "coordinates": "Coordonnées",
      "country": "Pays",
      "credit": "Crédit",
      "creditManagement": "Gestion des Crédits",
      "creditRequired": "Insérez le crédit",
      "credits": "Crédits",
      "creditsAddedSuccess": "Crédits ajoutés avec succès à tous les utilisateurs.",
      "days": "Jours",
      "desUser": "Dissocier Utilisateur",
      "downloadData": "Télécharger contact",
      "enterFullCredit": "Insérez le crédit total",
      "errorDesUser": "Impossible de dissocier l'utilisateur. Veuillez réessayer.",
      "errorDownloadingMeasures": "Erreur lors du téléchargement des mesures",
      "errorFindUsers": "Utilisateur non trouvé. Veuillez vérifier l'ID et réessayer.",
      "fullCredit": "Crédit Total",
      "initialCredit": "Crédit Initial",
      "initialCreditUpdatedSuccess": "Crédit initial mis à jour avec succès.",
      "insertCreditModal": "Entrez la nouvelle valeur totale des crédits pour l'utilisateur :",
      "lastConnectionDate": "Dernière date de connexion",
      "lastMeasure": "Dernière Mesure",
      "lastUsersFromMachine": "Derniers utilisateurs de la machine",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "machineData": "Données de la machine",
      "maxBloodPressure": "Pression artérielle maximale",
      "measureRegistration": "Enregistrement des Mesures",
      "minBloodPressure": "Pression artérielle minimale",
      "minCreditsSetSuccess": "Crédits minimums définis avec succès.",
      "model": "Modèle",
      "month": "Mois",
      "myMachines": "Mes Machines",
      "myOrg": "Mon Organisation",
      "na": "N/D",
      "noCountrySelected": "Sélectionnez un pays...",
      "noMachine": "Aucune machine sélectionnée",
      "noRegistryInterval": "Aucun enregistrement dans cette période",
      "noResults": "Aucun résultat trouvé",
      "numMachines": "Nombre de Machines",
      "operationError": "Une erreur s'est produite lors de l'exécution de l'opération.",
      "orgData": "Données de l'Organisation",
      "orgName": "Organisation",
      "postalcode": "Code Postal",
      "processing": "Traitement...",
      "province": "Province",
      "regDate": "Date d'Enregistrement",
      "registerUser": "Voulez-vous enregistrer l'utilisateur ?",
      "regiteredMeasures": "Mesures Enregistrées",
      "save": "Enregistrer les Modifications",
      "search": "Rechercher",
      "searchUser": "Rechercher un Utilisateur",
      "seeAll": "Voir Tout",
      "seeLast": "Voir les Derniers",
      "seeMeasurements": "Voir les Mesures",
      "selectAction": "Sélectionnez une Action",
      "serial": "Numéro de Série",
      "serverDate": "Date du Serveur",
      "setCredits": "Définir les Crédits",
      "setMinCredits": "Définir un Crédit Minimum",
      "softwareVersion": "Version du Logiciel",
      "totalCredits": "Nouveau Total de Crédits",
      "unregisterUsers": "Êtes-vous sûr de vouloir dissocier cet utilisateur ?",
      "updateInitialCredit": "Mettre à jour le Crédit Initial",
      "userDataAndMeasures": "Données Utilisateur et Mesures",
      "userEvolution": "Évolution de l'Utilisateur",
      "users": "Utilisateurs",
      "viewReports": "Voir les Rapports",
      "year": "Année",
      //
      //
      "orgSelection": "Mesures de l'organisation",
      "machinesSelection": "Mesures de la machine",
      "selectMesureOrigin": "Sélectionnez le type de mesure à rechercher.",
      "equipment": "Équipement",
      "largeDownload": "Téléchargement des données... cela peut prendre plusieurs minutes",
      "timeZone": 'Fuseau horaire',
      "oldPasswordPlaceholder": "Entrez votre mot de passe actuel",
      "invalidUserId": "ID utilisateur invalide",
      "lastWeek": "La Semaine Dernière",
      "lastMonth": "Le Mois Dernier",
      "last90Days": "Les 90 Derniers Jours",
      "setBirthDateAndSex": "Définir la Date de Naissance et le Sexe",
      "selectGender": "Sélectionner le Sexe",
      "errorOnSetUserInfo": "Veuillez remplir tous les champs correctement et accepter les termes.",
      "internalCode": "Code Interne",
      "orgRegistrationDate": "Date d'Enregistrement à l'Organisation",
      "disabledAccess": "Accès Désactivé",
      "vipUser": "Utilisateur VIP",
      "yes": "Oui",
      "no": "Non",
      "error": "Erreur",
      "addCreditsToAllDescription": "Ajoutez la valeur spécifiée à tous les utilisateurs de l'organisation.",
      "setMinCreditsDescription": "Augmentez le crédit de tous les utilisateurs à la valeur spécifiée. Cela ne s'appliquera pas aux utilisateurs qui ont un crédit supérieur à la valeur spécifiée.",
      "updateInitialCreditDescription": "Définissez la valeur spécifiée comme crédit initial pour l'organisation.",
      "edit": "Modifier",
      "minPressureAbbr": "Press. Min.",
      "maxPressureAbbr": "Press. Max.",
      "addOrder": "Ajouter Contact",
      "fecha": "Date",
      "cliente": "Client",
      "direccion": "Adresse",
      "codPostal": "Code Postal",
      "poblacion": "Ville",
      "provincia": "Province",
      "pais": "Pays",
      "telefono": "Téléphone",
      "email": "Email",
      "modelo": "Modèle",
      "observaciones": "Observations",
      "condiciones": "Conditions",
      "addOrderButton": "Ajouter Contact",
      "customerData": "Données du Client",
      "searchAddress": "Rechercher Adresse",
      "enterAddress": "Entrer Adresse",
      "editOrder": "Modifier Contact",
      "saveChangesButton": "Enregistrer les Modifications",
      "deleteOrder": "Supprimer Contact",
      "orderDetails": "Détails du Contact",
      "orderId": "ID du Contact",
      "orderDate": "Date du Contact",
      "orderAddress": "Adresse du Contact",
      "orderPhone": "Téléphone du Contact",
      "orderEmail": "Email du Contact",
      "orderModel": "Modèle du Contact",
      "orderObservations": "Observations du Contact",
      "editOrderButton": "Modifier Contact",
      "deleteOrderButton": "Supprimer Contact",
      "edit_columns": "Modifier les Colonnes"
    }
  },
  pt: {
    translation: {
      //Login
      "welcome": "Bem-vindo a Keito ",
      "eHealth": "Contatos",
      "intro": "Digite seu N.º de usuário e senha",
      //
      "titlePassword": "Senha",
      "userNumber": "N.º usuário",
      "userNumberPlaceholder": " N.º usuário",
      "password": "Senha",
      "passwordPlaceholder": "Sua senha",
      "rememberMe": "Lembre-me",
      "login": "Acessar",
      "noAccount": "Ainda não tem uma conta?",
      "authError": "Erro de autenticação",
      //Register Registro
      "signUp": "Registrar-se",
      "title-register": "Registro em Keito",
      "intro-register": "Preencha os dados para criar uma conta",
      "genderAtBirth": "Sexo ao nascer",
      "male": "Homem",
      "female": "Mulher",
      "dateOfBirth": "Data de nascimento",
      "dateOfBirthPlaceholder": "Sua data de nascimento",
      "enterPassword": "Digite a senha",
      "newPasswordPlaceholder": "Sua nova senha",
      "repeatPassword": " Repita a senha",
      "repeatPasswordPlaceholder": "Repita sua nova senha",
      "acceptTerms": "Aceitar as Condições e Termos de Uso",
      "register": "Registrar-se",
      "noOrders": "Nenhum contato disponível",
      "alreadyHaveAccount": "Você já tem uma conta?",
      "signIn": "Iniciar sessão",
      "titleMesurements": "Minhas medidas",
      "errorDate": "Selecione a sua data de nascimento!",
      "errorAccept": "Você deve aceitar as Condições e Termos de uso!",
      "errorPswIncorrect": "O formato da senha está incorreto, a senha deve ter pelo menos 5 caracteres!",
      //MainScreen
      "weight": "Peso",
      "weight-units": "Kg",
      "height": "Altura",
      "height-units": "Cm",
      "bmi": "IMC",
      "bmi-units": "Kg/m",
      "pressure": " Pressão Arterial",
      "pressure-units": "mmHg",
      "max-Sis": "Máxima Sistólica",
      "min-Dias": "Mínima Diastólica",
      "temperature": "Temperatura",
      "temperature-exp": "Temp.",
      "temperature-units": "ºC",
      "spo2": "SpO2",
      "spo2-units": "%",
      "pulse": "Pulso",
      "pulse-units": "ppm",
      "bfi": "% Gordura",
      "bfi-units": "%",
      "snormal": "Normal",
      "shigh": "Alta",
      "verylow": "Muito Baixo",
      "low": "Baixo",
      "mediumlow": "Meio Baixo",
      "mediumhigh": "Meio Alto",
      "high": "Alto",
      "veryhigh": "Muito Alto",
      "deletedAccount": "Esta conta foi eliminada.",
      "sureDelete": "Tem certeza de que deseja eliminar a conta?",
      "errorDelete": "Erro ao eliminar a conta.",
      "delete": "Eliminar",
      "changePassword": "Alterar a senha",
      "formatIncorrect": "O formato da senha está incorreto.",
      "passwordOk": "A senha foi atualizada com sucesso.",
      "errorChangePassword": " Erro ao alterar a senha.",
      "closeSession": "Fechar Sessão",
      "deleteUser": "Eliminar usuário",
      "alias": "Apelido (Opcional)",
      "sureDeleteFromList": "Tem certeza de que deseja excluir o usuário da lista?",
      "addUser": "Adicionar Usuário",
      "userExist": "O usuário já existe na lista",
      "default": "Predeterminado",
      "healthConnectNotAvailable": "O plugin de saúde não está disponível. Vá para a Play Store e baixe o aplicativo Health Connect. Certifique-se de conceder permissões ao Google Fit e Keito eHealth.",
      "goToPlayStore": "Ir para Play Store",
      "connectWithAppsAndroid": "Conectar com Google Fit",
      "connectWithAppsIos": "Conectar com Apple Health",
      "disconnectFromApps": "Desconectar de aplicativos...",
      //User birthdate ok
      "needinfo": "Por favor indique o seu género, data de nascimento e palavra-chave final",
      "errorBirthDate": "Você deve selecionar seu sexo, data de nascimento, senha e aceitar as Condições e Termos de uso!",
      //Añadir o Registrar Usuario Dialog
      "addOrRegUser": "Deseja adicionar um usuário existente ou registrar um novo?",
      "userRegistered": "Usuário registrado",
      "regiterUser": "Registrar usuário",
      "addChangeUser": "Adicionar/Alterar Usuário",
      "associateUser": "Associar Usuário",
      //Pantalla QR Tela QR
      "identifyTitle": "Identifique-se num equipamento Keito",
      "selectCodeType": "Seleciona",
      "codeType": "Tipo de código",
      "helpGifAltText": "Gif de ajuda do Keito E-Saúde",
      "insertCodeInstructions": "Insira seu código no dispositivo conforme indicado no vídeo",
      "needHelp": "Precisa de ajuda?",
      "contactUs": "Contate-nos",
      //Pantalla Last Ticket Tela do último ticket
      "lastTicket": "Último Ticket",
      "ticket": "Ticket",
      "equipmentNumber": "Equipamento",
      "userId": "Usuário",
      "userAge": "Idade",
      "userSex": "Sexo",
      "measurements": "Medidas",
      "references": "Referências",
      "title-bfi": 'Gordura corporal estimada',
      "%-bfi": "% Gordura",
      "windex-bfi": "Índice de água",
      "fmass-bfi": "Massa gorda",
      "fwmass-bfi": "Massa sem gordura",
      "wmass-bfi": "Massa de água",
      "normalWeightBetween": "Peso normal entre",
      "and": "e",
      "yourBmiIs": "Seu IMC é",
      "shouldBeBetween": "Normalmente, deve estar entre",
      "bloodPressureAccordingToWHO": "Pressão Arterial em mmHg de acordo com a OMS",
      "normalUntil": "Normal, até",
      "highBetween": "Alta, Entre",
      "hypertension": "Hipertensão",
      "normalSpo2Value": "Valor normal da oximetria de pulso",
      "normalSpo2Between": "Normal entre",
      "normalFatIndex": "Índice de gordura normal",
      "normalFatMass": "Massa Gorda Normal",
      "noMeasures": "Este usuário não tem medidas",
      "noMeasuresUser": "Este usuário não tem medidas registradas neste intervalo",
      "noMeasuresInterval": "Esta organização não tem medidas registradas neste intervalo",
      //DetailScreen Tela de detalhes
      "value": "Valor",
      "weightDescription": "O peso corporal é a quantidade de massa que o corpo de um indivíduo tem",
      "heightDescription": "A altura é a medida de uma pessoa da cabeça aos pés",
      "bmiDescription": "O Índice de Massa Corporal (IMC) mede o conteúdo de gordura corporal em relação à altura e ao peso",
      "pressureDescription": "A pressão arterial é a força do sangue contra as paredes dos vasos sanguíneos",
      "pulseDescription": "A frequência cardíaca é o número de vezes que o coração se contrai durante um minuto (batimentos por minuto)",
      "spo2Description": "A saturação de oxigênio (SpO2) mede o nível de oxigênio no sangue",
      "temperatureDescription": "A temperatura corporal é uma medida da capacidade do corpo para gerar e eliminar calor",
      "bfiDescription": "A massa gorda reflete a percentagem do peso corporal constituída por tecido adiposo",
      "selectDateRange": "Selecione um intervalo de tempo",
      "last5": "Últimas 5",
      "lastYear": " Último ano",
      "all": "Todas",
      "custom": "Personalizado",
      "startDate": "Data de início",
      "endDate": "Data final",
      "history": "Historial",
      "cancel": "Cancelar",
      "ok": "Ok",
      "date": "Data",
      "hour": "Hora",
      //Error Dialog set 2 dates
      "incorrectInterval": "Erro de formato de data incorreto.",
      //Management
      "BloodPres": "Pressão arterial",
      "CookiesPolicy": "Política de Cookies",
      "IGP": "% Gordura",
      "LegalNotice": "Aviso Legal, Termos e Condições",
      "PrivacyPolicy": "Política de Privacidade",
      "accept": "Aceitar",
      "addCredit": "Adicionar Crédito",
      "addCreditSuccess": "Créditos atualizados com sucesso",
      "addCreditsToAll": "Adicionar créditos a todos",
      "allUsers": "Todos os usuários",
      "anonymousMeasures": "Medições anônimas",
      "city": "Cidade",
      "confirm": "Confirmar",
      "coordinates": "Coordenadas",
      "country": "País",
      "credit": "Crédito",
      "creditManagement": "Gestão de Créditos",
      "creditRequired": "Insira o crédito",
      "credits": "Créditos",
      "creditsAddedSuccess": "Créditos adicionados com sucesso a todos os usuários.",
      "days": "Dias",
      "desUser": "Desvincular Usuário",
      "downloadData": "Baixar contactos",
      "enterFullCredit": "Insira o crédito total",
      "errorDesUser": "Não foi possível desvincular o usuário. Tente novamente.",
      "errorDownloadingMeasures": "Erro ao baixar as medições",
      "errorFindUsers": "Usuário não encontrado. Verifique o ID e tente novamente.",
      "fullCredit": "Crédito Total",
      "initialCredit": "Crédito Inicial",
      "initialCreditUpdatedSuccess": "Crédito inicial atualizado com sucesso.",
      "insertCreditModal": "Insira o novo valor total de créditos para o usuário:",
      "lastConnectionDate": "Data da última conexão",
      "lastMeasure": "Última Medição",
      "lastUsersFromMachine": "Últimos usuários da máquina",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "machineData": "Dados da máquina",
      "maxBloodPressure": "Pressão arterial máxima",
      "measureRegistration": "Registro de Medições",
      "minBloodPressure": "Pressão arterial mínima",
      "minCreditsSetSuccess": "Créditos mínimos definidos com sucesso.",
      "model": "Modelo",
      "month": "Mês",
      "myMachines": "Minhas Máquinas",
      "myOrg": "Minha Organização",
      "na": "N/D",
      "noCountrySelected": "Selecione um país...",
      "noMachine": "Nenhuma máquina selecionada",
      "noRegistryInterval": "Nenhum registro neste período",
      "noResults": "Nenhum resultado encontrado",
      "numMachines": "Número de Máquinas",
      "operationError": "Ocorreu um erro ao realizar a operação.",
      "orgData": "Dados da Organização",
      "orgName": "Organização",
      "postalcode": "CEP",
      "processing": "Processando...",
      "province": "Estado",
      "regDate": "Data de Registro",
      "registerUser": "Deseja registrar o usuário?",
      "regiteredMeasures": "Medições Registradas",
      "save": "Salvar Alterações",
      "search": "Pesquisar",
      "searchUser": "Pesquisar Usuário",
      "seeAll": "Ver Todos",
      "seeLast": "Ver Últimos",
      "seeMeasurements": "Ver Medições",
      "selectAction": "Selecione uma Ação",
      "serial": "Número de Série",
      "serverDate": "Data do Servidor",
      "setCredits": "Definir Créditos",
      "setMinCredits": "Definir Créditos Mínimos",
      "softwareVersion": "Versão do Software",
      "totalCredits": "Total de novos créditos",
      "unregisterUsers": "Tem certeza de que deseja desvincular este usuário?",
      "updateInitialCredit": "Atualizar Crédito Inicial",
      "userDataAndMeasures": "Dados do Usuário e Medições",
      "userEvolution": "Evolução do Usuário",
      "users": "Usuários",
      "viewReports": "Ver Relatórios",
      "year": "Ano",
      //
      "orgSelection":"Medições da organização",
      "machinesSelection":"Medições da máquina",
      "selectMesureOrigin":"Selecione o tipo de medição para buscar.", 
      "equipment":"Equipamento",
      "largeDownload": "Baixando dados... isso pode levar vários minutos", 
      "timeZone":'Fuso horário',
      "oldPasswordPlaceholder": "Digite sua senha atual",
      "invalidUserId": "ID de usuário inválido",
      "lastWeek": "Última Semana",
      "lastMonth": "Último Mês",
      "last90Days": "Últimos 90 Dias",
      "setBirthDateAndSex": "Definir Data de Nascimento e Sexo",
      "selectGender": "Selecionar Gênero",
      "errorOnSetUserInfo": "Por favor, preencha todos os campos corretamente e aceite os termos.",
      "internalCode": "Código Interno",
      "orgRegistrationDate": "Data de Registro na Organização",
      "disabledAccess": "Acesso Desativado",
      "vipUser": "Usuário VIP",
      "yes": "Sim",
      "no": "Não",
      "error": "Erro",
      "addCreditsToAllDescription": "Adicione o valor especificado a todos os usuários da organização.",
      "setMinCreditsDescription": "Aumente o crédito de todos os usuários para o valor especificado. Não se aplicará a usuários que tenham um crédito superior ao valor especificado.",
      "updateInitialCreditDescription": "Defina o valor especificado como crédito inicial para a organização.",
      "edit": "Editar",
      "minPressureAbbr": "Press. Mín.",
      "maxPressureAbbr": "Press. Máx.",
      "addOrder": "Adicionar Contato",
      "fecha": "Data",
      "cliente": "Cliente",
      "direccion": "Endereço",
      "codPostal": "Código Postal",
      "poblacion": "Cidade",
      "provincia": "Estado",
      "pais": "País",
      "telefono": "Telefone",
      "email": "Email",
      "modelo": "Modelo",
      "observaciones": "Observações",
      "condiciones": "Condições",
      "addOrderButton": "Adicionar Contato",
      "customerData": "Dados do Cliente",
      "searchAddress": "Buscar Endereço",
      "enterAddress": "Inserir Endereço",
      "editOrder": "Editar Contato",
      "saveChangesButton": "Salvar Alterações",
      "deleteOrder": "Excluir Contato",
      "orderDetails": "Detalhes do Contato",
      "orderId": "ID do Contato",
      "orderDate": "Data do Contato",
      "orderAddress": "Endereço do Contato",
      "orderPhone": "Telefone do Contato",
      "orderEmail": "Email do Contato",
      "orderModel": "Modelo do Contato",
      "orderObservations": "Observações do Contato",
      "editOrderButton": "Editar Contato",
      "deleteOrderButton": "Excluir Contato",
      "edit_columns": "Editar Colunas"
    }
  }
};

export function initializeI18next(language) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: language.split('-')[0], // Obtén el código del idioma (ejemplo: 'en' de 'en-US')
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    });
}

